class StickyAddToCart extends HTMLElement {
    constructor() {
        super();
        this.sticky = this;
        this.stickyBounds = document.getElementById('product-add-to-cart') || document.querySelector('[data-combo-addtocart]');
        this.closeSticky = this.querySelector('[data-close-sticky-add-to-cart]');
        this.expandSticky = this.querySelector('[data-expand-sticky-add-to-cart]');

        this.closeSticky?.addEventListener('click', this.setCloseSticky.bind(this));
        this.expandSticky?.addEventListener('click', this.setExpandSticky.bind(this));

        this.openStickyButton = document.getElementById('show-sticky-product');
        this.closeModal = this.closeStickyModal.bind(this);
    }

    connectedCallback() {
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);

        this.openStickyButton.addEventListener('click', this.openStickyModal.bind(this));
        document.addEventListener('click', (e) => {
            if (
                e.target.matches('.background-overlay') ||
                e.target.closest('[data-close-sticky-mobile]') != null ||
                e.target.matches('[data-close-sticky-mobile]')
            ) {
                this.closeModal();
            }
        });

        const height = this.closest('[data-sticky-add-to-cart]').clientHeight;
        this.sticky.querySelector('.sticky-product-mobile').style.bottom = height + 'px';

        // Mobile 2-step:
        // Mobile 2-step with custom variant picker (no ugly native select)
        const stickyBarBtn = this.querySelector('#product-sticky-add-to-cart');
        if (stickyBarBtn) {
            stickyBarBtn.addEventListener('click', (e) => {
                if (window.innerWidth > 767) return; // desktop — normal behaviour
                const selectEl = this.querySelector('.sticky-options select');
                if (!selectEl) return; // no variants — submit naturally

                if (!this.sticky.classList.contains('mobile-expanded')) {
                    // Step 1 → Step 2: expand and open picker
                    e.preventDefault();
                    e.stopPropagation();
                    this.sticky.classList.add('mobile-expanded');
                    this._openVariantPicker(selectEl);
                } else if (!selectEl.dataset.picked) {
                    // Expanded but no variant picked yet — open picker again
                    e.preventDefault();
                    e.stopPropagation();
                    this._openVariantPicker(selectEl);
                }
                // Expanded + variant picked → submit naturally
            }, true);
        }

        // Also allow re-opening picker by tapping the variant display area
        this.addEventListener('click', (e) => {
            if (window.innerWidth > 767) return;
            const optionsArea = e.target.closest('.sticky-options');
            if (!optionsArea) return;
            e.preventDefault();
            e.stopPropagation();
            const selectEl = this.querySelector('.sticky-options select');
            if (selectEl) this._openVariantPicker(selectEl);
        });
    }

    openStickyModal() {
        document.body.classList.add('show-mobile-options');
    }

    closeStickyModal() {
        document.body.classList.remove('show-mobile-options');
    }

    disconnectedCallback() {
        window.removeEventListener('scroll', this.onScrollHandler);
    }

    onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const offsetScroll = $(this.stickyBounds).offset().top + $(this.stickyBounds).outerHeight(true) + 100;
        const winHeight = window.innerHeight;
        const docHeight = document.body.clientHeight;

        if (scrollTop > offsetScroll && scrollTop + winHeight < docHeight) {
            requestAnimationFrame(this.show.bind(this));

            if (this.sticky.classList.contains('style-1')) {
                let height = 0;
                const previewBar = document.getElementById('preview-bar-iframe'),
                    toolbarMobile = document.querySelector('.halo-sticky-toolbar-mobile');

                if (previewBar && window.getComputedStyle(previewBar).display !== 'none') {
                    height = previewBar.offsetHeight;
                } else if (toolbarMobile) {
                    height = toolbarMobile.offsetHeight;
                }

                this.sticky.style.top = 'auto';
                this.sticky.style.bottom = `${height}px`;
            } else if (this.sticky.classList.contains('style-2')) {
                if (document.body.classList.contains('scroll-up')) {
                    let height = document.querySelector('sticky-header').offsetHeight;
                    if (window.innerWidth < 551) height = height + 20;
                    this.sticky.style.top = `${height}px`;
                } else if (document.body.classList.contains('scroll-down')) {
                    this.sticky.style.top = window.innerWidth > 550 ? 0 : '20px';
                }
            }
        } else {
            requestAnimationFrame(this.hide.bind(this));
        }

        this.currentScrollTop = scrollTop;
    }

    hide() {
        this.sticky.classList.remove('show-sticky', 'hidden-sticky', 'full-sticky', 'animate', 'mobile-expanded');
        document.body.classList.remove('show-mobile-options');
        if (window.innerWidth <= 767) {
            document.querySelectorAll('.hf-copyright-bar').forEach(el => el.style.display = '');
        }
    }

    show() {
        this.sticky.classList.add('show-sticky', 'animate');
        if (window.innerWidth <= 767) {
            document.querySelectorAll('.hf-copyright-bar').forEach(el => el.style.display = 'none');
        }
    }

    _openVariantPicker(selectEl) {
        // Remove any existing picker
        const existing = document.getElementById('sticky-variant-picker');
        if (existing) existing.remove();

        // Get current selected value
        const currentVal = selectEl.value;

        // Build options HTML
        const options = Array.from(selectEl.options);
        const optionsHTML = options.map(opt => {
            const isDisabled = opt.disabled;
            const isSelected = opt.value === currentVal;
            const rawText = opt.text.trim();

            // Check soldout BEFORE cleaning the label
            const soldOut = opt.disabled || rawText.toLowerCase().includes('sold out') || rawText.includes('sold_out');

            // Clean label - remove price part and soldout suffix if present
            const label = rawText
                .replace(/\s*-\s*Rs\..*$/i, '')
                .replace(/\s*\(.*\)\s*$/, '')
                .replace(/\s*-?\s*sold\s*out\s*$/i, '')
                .trim();

            return `<button
                class="svc-option${isSelected ? ' svc-selected' : ''}${isDisabled ? ' svc-disabled' : ''}"
                data-value="${opt.value}"
                ${isDisabled ? 'disabled' : ''}
            >
                <span class="svc-label">${label}${soldOut ? '<span class="svc-soldout">Sold Out</span>' : ''}</span>
                ${isSelected ? '<span class="svc-check"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg></span>' : '<span class="svc-check"></span>'}
            </button>`;
        }).join('');

        // Get product title for sheet header
        const productTitle = document.querySelector('.productView .productView-title, .productView h1')?.textContent?.trim() || 'Select Option';

        // Build sheet
        const sheet = document.createElement('div');
        sheet.id = 'sticky-variant-picker';
        sheet.innerHTML = `
            <div class="svc-backdrop"></div>
            <div class="svc-sheet">
                <div class="svc-handle-wrap">
                    <div class="svc-handle"></div>
                </div>
                <div class="svc-title">Select Size</div>
                <div class="svc-options">${optionsHTML}</div>
                <div class="svc-footer">
                    <button class="svc-cancel">Cancel</button>
                </div>
            </div>`;
        document.body.appendChild(sheet);

        // Animate in
        requestAnimationFrame(() => {
            requestAnimationFrame(() => sheet.classList.add('svc-open'));
        });

        const close = (cancelled = false) => {
            sheet.classList.remove('svc-open');
            setTimeout(() => { if (sheet.parentNode) sheet.remove(); }, 350);
            if (cancelled && !selectEl.dataset.picked) {
                this.sticky.classList.remove('mobile-expanded');
            }
        };

        sheet.querySelector('.svc-backdrop').addEventListener('click', () => close(true));
        sheet.querySelector('.svc-handle-wrap').addEventListener('click', () => close(true));
        sheet.querySelector('.svc-cancel').addEventListener('click', () => close(true));

        // Option selected
        sheet.querySelectorAll('.svc-option:not(.svc-disabled)').forEach(btn => {
            btn.addEventListener('click', () => {
                const val = btn.dataset.value;

                // Update select
                selectEl.value = val;
                selectEl.dataset.picked = '1';
                selectEl.dispatchEvent(new Event('change', { bubbles: true }));

                // Update the visible label in the bar
                const displayLabel = btn.querySelector('.svc-label').childNodes[0].textContent.trim();
                const barSelect = this.querySelector('.sticky-options select');
                if (barSelect) {
                    // Update the displayed text in the custom select face
                    let face = this.querySelector('.svc-select-face');
                    if (!face) {
                        face = document.createElement('div');
                        face.className = 'svc-select-face';
                        barSelect.parentNode.insertBefore(face, barSelect);
                    }
                    face.textContent = displayLabel;
                }

                close(false);
            });
        });
    }

    setCloseSticky(event) {
        event.preventDefault();
        if (this.sticky.classList.contains('full-sticky')) {
            this.sticky.classList.remove('full-sticky');
        } else {
            this.sticky.classList.add('hidden-sticky');
        }
    }

    setExpandSticky(event) {
        event.preventDefault();
        this.sticky.classList.add('full-sticky');
    }
}

customElements.define('sticky-add-to-cart', StickyAddToCart);

/* ─────────────────────────────────────────────────────────
   VariantStickyAddToCart  (SELECT-based dropdown)
   ───────────────────────────────────────────────────────── */
class VariantStickyAddToCart extends HTMLElement {
    constructor() {
        super();
        this.item = $(this).closest('.productView');
        this.sticky = $(this).closest('.productView-stickyCart');
        this.addEventListener('change', this.onVariantChange.bind(this));
    }

    onVariantChange(event) {
        this.updateOptions();
        this.updateMasterId();
        this.updatePickupAvailability();
        this.updateMedia(200);
        this.updateURL();
        this.updateVariantInput();
        this.renderProductAjaxInfo();
        this.renderProductInfo();
        this.updateAttribute(!this.currentVariant || !this.currentVariant.available);
    }

    updateOptions() {
        // For a single <select> that holds variant IDs (the sticky bar select)
        // value is the variant ID directly — handle both cases:
        //   Case A: select value = variant ID  (sticky bar dropdown)
        //   Case B: select value = option label (per-option selects)
        const selects = Array.from(this.querySelectorAll('select'));

        // If the first select's value looks like a numeric variant ID,
        // resolve directly by ID (Case A).
        if (selects.length === 1 && /^\d+$/.test(selects[0].value)) {
            this._resolveByVariantId = parseInt(selects[0].value, 10);
            this.options = null; // signal to updateMasterId
        } else {
            this._resolveByVariantId = null;
            this.options = selects.map((s) => s.value);
        }
    }

    decodeOptions() {
        if (!this.options) return;
        this.options = this.options.map((o) => this.decodeOption(o));
    }

    decodeOption(option) {
        if (option) {
            return option.split('Special_Double_Quote').join('"').split('Special_Slash').join('/');
        }
        return null;
    }

    encodeOption(option) {
        if (option) {
            return option.split('"').join('Special_Double_Quote').split('/').join('Special_Slash');
        }
        return null;
    }

    updateMasterId() {
        const variants = this.getVariantData();

        // ── Case A: the sticky bar <select> stores variant IDs directly ──
        if (this._resolveByVariantId) {
            this.currentVariant = variants.find((v) => v.id === this._resolveByVariantId) || null;
            return;
        }

        // ── Case B: per-option selects store option labels ──
        this.decodeOptions();
        this.currentVariant = variants.find((variant) => {
            return !variant.options
                .map((option, index) => this.options[index] === option)
                .includes(false);
        }) || null;
    }

    updateMedia(time) {
        if (!this.currentVariant || !this.currentVariant?.featured_media) return;

        const itemImage = this.item.find('.sticky-image');
        const image = this.currentVariant?.featured_image;
        if (!itemImage || !image) return;

        itemImage.find('img').attr({
            src: image.src,
            srcset: image.src,
            alt: image.alt,
        });

        const newMedia = document.querySelectorAll(
            `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
        );
        if (!newMedia) return;
        window.setTimeout(() => {
            $(newMedia).trigger('click');
        }, time);
    }

    updateURL() {
        if (!this.currentVariant) return;
        window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
        if (!this.currentVariant) return;
        const productForms = document.querySelectorAll(
            `#product-form-${this.dataset.product}, #product-form-installment-${this.dataset.product}, #product-form-sticky-${this.dataset.product}`
        );
        productForms.forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            if (!input) return;
            input.value = this.currentVariant.id;
            input.dispatchEvent(new Event('change', { bubbles: true }));
        });
    }

    updatePickupAvailability() {
        const pickUpAvailability = document.querySelector('pickup-availability');
        if (!pickUpAvailability) return;
        if (this.currentVariant?.available) {
            pickUpAvailability.fetchAvailability(this.currentVariant.id);
        } else {
            pickUpAvailability.removeAttribute('available');
            pickUpAvailability.innerHTML = '';
        }
    }

    renderProductAjaxInfo() {
        if (!this.currentVariant) return;
        fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
            .then((r) => r.text())
            .then((responseText) => {
                const id = `product-price-${this.dataset.product}`;
                const html = new DOMParser().parseFromString(responseText, 'text/html');
                const destination = document.getElementById(id);
                const source = html.getElementById(id);
                if (source && destination) destination.innerHTML = source.innerHTML;
                document.getElementById(id)?.classList.remove('visibility-hidden');
            });
    }

    renderProductInfo() {
        var variantList = this.getVariantData().filter((v) => v.available);

        var selectedOption1 = this.currentVariant?.option1,
            selectedOption2 = this.currentVariant?.option2,
            selectedOption3 = this.currentVariant?.option3,
            options = this.item.find('.product-form__input:not(.mobile)'),
            optionsMobile = this.item.find('.product-form__input.mobile'),
            checkStickyVariant = false;

        const renderOptions = (options) => {
            $.each(options, (index, element) => {
                var position = $(element).data('option-index'),
                    type = $(element).data('product-attribute');

                switch (position) {
                    case 0:
                        $(element).find('[data-header-option]').text(selectedOption1);
                        if (type == 'set-select') {
                            $(element).find('.select__select').val(selectedOption1);
                            $(element).find('.select__select option').each((idx, elt) => {
                                elt.value == selectedOption1 ? $(elt).attr('selected', 'selected') : $(elt).removeAttr('selected');
                            });
                        } else {
                            $(element).find('.product-form__radio').prop('checked', false);
                            $(element).find(`.product-form__radio[value="${this.encodeOption(selectedOption1)}"]`).prop('checked', true);
                        }

                        if (selectedOption2) {
                            var inputList = $(options[1]),
                                input = inputList.find('.product-form__radio'),
                                selectOption = inputList.find('.select__select option'),
                                option1List = variantList.filter((v) => v.option1 === selectedOption1);

                            if (type == 'set-rectangle') {
                                input.each((idx, elt) => {
                                    var optionSoldout = option1List.find((v) => v.option2 == this.decodeOption($(elt).val()));
                                    $(elt).next()[optionSoldout == undefined ? 'removeClass' : 'addClass']('available');
                                    $(elt).next()[optionSoldout == undefined ? 'addClass' : 'removeClass']('soldout');
                                });
                            } else {
                                selectOption.each((idx, elt) => {
                                    var optionSoldout = option1List.find((v) => v.option2 == this.decodeOption($(elt).val()));
                                    optionSoldout == undefined ? $(elt).attr('disabled', true) : $(elt).removeAttr('disabled');
                                });
                            }
                        }
                        break;

                    case 1:
                        $(element).find('[data-header-option]').text(selectedOption2);
                        if (type == 'set-select') {
                            $(element).find('.select__select').val(selectedOption2);
                            $(element).find('.select__select option').each((idx, elt) => {
                                elt.value == selectedOption2 ? $(elt).attr('selected', 'selected') : $(elt).removeAttr('selected');
                            });
                        } else {
                            $(element).find('.product-form__radio').prop('checked', false);
                            $(element).find(`.product-form__radio[value="${this.encodeOption(selectedOption2)}"]`).prop('checked', true);
                        }

                        if (selectedOption1) {
                            var inputList = $(options[0]),
                                input = inputList.find('.product-form__radio'),
                                selectOption = inputList.find('.select__select option'),
                                option2List = variantList.filter((v) => v.option2 === selectedOption2);

                            if (type == 'set-rectangle') {
                                input.each((idx, elt) => {
                                    var optionSoldout = option2List.find((v) => v.option1 == this.decodeOption($(elt).val()));
                                    $(elt).next()[optionSoldout == undefined ? 'removeClass' : 'addClass']('available');
                                    $(elt).next()[optionSoldout == undefined ? 'addClass' : 'removeClass']('soldout');
                                });
                            } else {
                                selectOption.each((idx, elt) => {
                                    var optionSoldout = option2List.find((v) => v.option1 == this.decodeOption($(elt).val()));
                                    optionSoldout == undefined ? $(elt).attr('disabled', true) : $(elt).removeAttr('disabled');
                                });
                            }
                        }
                        break;

                    case 2:
                        $(element).find('[data-header-option]').text(selectedOption3);
                        if (type == 'set-select') {
                            $(element).find('.select__select').val(selectedOption3);
                            $(element).find('.select__select option').each((idx, elt) => {
                                elt.value == selectedOption3 ? $(elt).attr('selected', 'selected') : $(elt).removeAttr('selected');
                            });
                        } else {
                            $(element).find('.product-form__radio').prop('checked', false);
                            $(element).find(`.product-form__radio[value="${this.encodeOption(selectedOption3)}"]`).prop('checked', true);
                        }

                        if (selectedOption1) {
                            var option3List = variantList.filter((v) => v.option3 === selectedOption3),
                                inputList = $(options[0]),
                                input = inputList.find('.product-form__radio'),
                                selectOption = inputList.find('.select__select option');

                            if (type == 'set-rectangle') {
                                input.each((idx, elt) => {
                                    var optionSoldout = option3List.find((v) => v.option1 == this.decodeOption($(elt).val()));
                                    $(elt).next()[optionSoldout == undefined ? 'removeClass' : 'addClass']('available');
                                    $(elt).next()[optionSoldout == undefined ? 'addClass' : 'removeClass']('soldout');
                                });
                            } else {
                                selectOption.each((idx, elt) => {
                                    var optionSoldout = option3List.find((v) => v.option1 == this.decodeOption($(elt).val()));
                                    optionSoldout == undefined ? $(elt).attr('disabled', true) : $(elt).removeAttr('disabled');
                                });
                            }
                        }
                        break;
                }
            });
        };

        renderOptions(options);
        renderOptions(optionsMobile);

        if (this.item.find('[data-sku]').length > 0) {
            this.item.find('[data-sku] .productView-info-value').text(this.currentVariant?.sku);
        }

        var inventory = this.currentVariant?.inventory_management;
        if (inventory != null) {
            var arrayInVarName = `product_inven_array_${this.dataset.product}`,
                inven_array = window[arrayInVarName];

            if (inven_array != undefined) {
                var inven_num = inven_array[this.currentVariant.id],
                    inventoryQuantity = parseInt(inven_num);

                this.item.find('input[name="quantity"]').attr('data-inventory-quantity', inventoryQuantity);

                if (this.item.find('[data-inventory]').length > 0) {
                    this.item.find('[data-inventory] .productView-info-value').text(
                        inventoryQuantity > 0 ? window.inventory_text.inStock : window.inventory_text.outOfStock
                    );
                }

                if (this.item.find('.productView-hotStock').length > 0) {
                    var hotStock = this.item.find('.productView-hotStock'),
                        maxStock = hotStock.data('hot-stock');
                    if (inventoryQuantity > 0 && inventoryQuantity <= maxStock) {
                        hotStock.text(window.inventory_text.hotStock.replace('[inventory]', inventoryQuantity)).show();
                    } else {
                        hotStock.hide();
                    }
                }
            }
        }
    }

    updateAttribute(disable = true) {
        const addButton = document.getElementById(`product-form-${this.dataset.product}`)?.querySelector('[name="add"]');
        const stickyButton = document.getElementById(`product-form-sticky-${this.dataset.product}`)?.querySelector('[name="add"]');

        var quantityInput = $('[data-sticky-add-to-cart] .quantity__input'),
            notifyMe = this.item.find('.productView-notifyMe'),
            stickyPrice = $('[data-sticky-add-to-cart] .sticky-price .money');

        var maxValue = parseInt(quantityInput.attr('data-inventory-quantity'));

        if (stickyPrice.length === 0) {
            stickyPrice = $('[data-sticky-add-to-cart] .sticky-price .money-subtotal');
        }

        if (disable) {
            var text = window.variantStrings.soldOut;

            this.item.removeClass('isChecked');
            quantityInput.attr('data-price', this.currentVariant?.price);
            quantityInput.attr('disabled', true);
            if (addButton) { addButton.setAttribute('disabled', true); addButton.textContent = text; }
            if (stickyButton) { stickyButton.setAttribute('disabled', true); stickyButton.textContent = text; }

            if (notifyMe.length > 0) {
                notifyMe.find('input[name="halo-notify-product-variant"]').val(this.currentVariant?.title);
                notifyMe.find('.notifyMe-text').empty();
                notifyMe.slideDown('slow');
            }
        } else {
            var text, subTotal = 0, price = this.currentVariant?.price;

            // Guard: price must be a valid positive number
            var validPrice = typeof price === 'number' && price > 0;

            if (window.subtotal?.show && validPrice) {
                // qty hidden/empty → fall back to 1 so price never multiplies by 0
                let qty = parseInt(quantityInput.val()) || 1;
                subTotal = qty * price;
                subTotal = Shopify.formatMoney(subTotal, window.money_format);
                if (window.currencyFormatted) subTotal = $(subTotal).text();

                if (window.subtotal.style == '1') {
                    const pdView_subTotal = document.querySelector('.productView-subtotal .money') ||
                        document.querySelector('.productView-subtotal .money-subtotal');
                    if (pdView_subTotal) pdView_subTotal.textContent = subTotal;
                    text = (this.currentVariant.available && maxValue <= 0)
                        ? window.variantStrings.preOrder
                        : window.variantStrings.addToCart;
                } else if (window.subtotal.style == '2') {
                    text = window.subtotal.text.replace('[value]', subTotal);
                }
            } else {
                if (validPrice) {
                    subTotal = Shopify.formatMoney(price, window.money_format);
                    if (window.currencyFormatted) subTotal = $(subTotal).text();
                }
                text = (this.currentVariant.available && maxValue <= 0)
                    ? window.variantStrings.preOrder
                    : window.variantStrings.addToCart;
            }

            this.item.addClass('isChecked');
            quantityInput.attr('data-price', this.currentVariant?.price);
            quantityInput.attr('disabled', false);
            if (addButton) { addButton.removeAttribute('disabled'); addButton.textContent = text; }
            if (stickyButton) { stickyButton.removeAttribute('disabled'); stickyButton.textContent = text; }

            // Only update price if we have a real formatted value (not zero/empty)
            if (subTotal && subTotal !== '0' && stickyPrice.length) stickyPrice.text(subTotal);

            if (notifyMe.length > 0) notifyMe.slideUp('slow');
        }
    }

    getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
    }
}

customElements.define('variant-sticky-selects', VariantStickyAddToCart);

/* ─────────────────────────────────────────────────────────
   VariantStickyRadios  (radio/swatch buttons)
   ───────────────────────────────────────────────────────── */
class VariantStickyRadios extends VariantStickyAddToCart {
    constructor() {
        super();
    }

    connectedCallback() {
        this.updateMediaTimeout = undefined;
    }

    onVariantChange(event) {
        this.updateOptions();
        this.updateMasterId();
        this.updatePickupAvailability();
        this.updateMedia(10);
        this.updateURL();
        this.updateVariantInput();
        this.updateSelectVariant();
        this.renderProductAjaxInfo();
        this.renderProductInfo();
        this.updateAttribute(!this.currentVariant || !this.currentVariant.available);
    }

    updateOptions() {
        const fieldsets = Array.from(this.querySelectorAll('fieldset'));
        this.options = fieldsets.map((fieldset) => {
            return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked)?.value;
        });
        this._resolveByVariantId = null; // always use options array for radios
    }

    updateMasterId() {
        this.decodeOptions();
        this.currentVariant = this.getVariantData().find((variant) => {
            return !variant.options
                .map((option, index) => this.options[index] === option)
                .includes(false);
        }) || null;
    }

    updateSelectVariant() {
        const selectElement = this.closest('.productView-stickyCart')?.querySelector('select');
        if (selectElement && this.currentVariant) {
            selectElement.value = this.currentVariant.id;
        }
    }

    updateMedia(time) {
        if (!this.currentVariant || !this.currentVariant?.featured_media) return;

        const itemImage = this.item.find('.sticky-image');
        const image = this.currentVariant?.featured_image;
        if (!itemImage || !image) return;

        itemImage.find('img').attr({ src: image.src, srcset: image.src, alt: image.alt });

        const newMedia = document.querySelectorAll(
            `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
        );
        if (!newMedia) return;

        clearTimeout(this.updateMediaTimeout);
        this.updateMediaTimeout = setTimeout(() => {
            $(newMedia).trigger('click');
        }, time);
    }

    openStickyModal() {
        document.body.classList.add('show-mobile-options');
    }

    closeStickyModal() {
        document.body.classList.remove('show-mobile-options');
    }
}

customElements.define('variant-sticky-radios', VariantStickyRadios);

function parseDoubleQuote(option, isDecoding = true) {
    if (!option) return option;
    return isDecoding
        ? option.replace('"', 'spc_dbl_qte')
        : option.replace('spc_dbl_qte', '"');
}